"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import DateFormat from "@/framework/timeformatter";
import API from "@ym-framework/api-utils";
let RenewVDDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.second = 5;
    this.showClose = false;
    this.datas = [];
    this.selectNoRenewTip = "";
    this.user_id = "";
    this.vd_size = 0;
    this.selectOptions = [
      {
        "value": "three",
        "label": this.$t("vd_renew_dialog.three_days_remind")
      },
      {
        "value": "seven",
        "label": this.$t("vd_renew_dialog.seven_days_remind")
      },
      {
        "value": "thirty",
        "label": this.$t("vd_renew_dialog.thirty_days_remind")
      }
    ];
  }
  open(data, id, tip) {
    if (tip) {
      this.selectNoRenewTip = tip;
    }
    this.datas = data;
    this.vd_size = data.length;
    this.user_id = id;
    this.renewVdDialog.show();
    this.timer_last();
  }
  timer_last() {
    let timer_last = setInterval(() => {
      if (this.second >= 0) {
        this.second = this.second - 1;
      }
      if (this.second === 0) {
        this.showClose = true;
      }
      if (this.second < 0) {
        clearInterval(timer_last);
        this.second = 5;
      }
    }, 1e3);
  }
  //日期类型转换
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  close() {
    return __async(this, null, function* () {
      yield this.checkSkipTips();
      this.renewVdDialog.hide();
    });
  }
  toRenewPage() {
    return __async(this, null, function* () {
      yield this.checkSkipTips();
      this.$emit("toRenew");
      this.renewVdDialog.hide();
    });
  }
  checkSkipTips() {
    return __async(this, null, function* () {
      try {
        if (this.selectNoRenewTip === null || this.selectNoRenewTip === "") {
          yield API.delete(`api://base.local/storages/users/${this.user_id}/preference/renew_tip_date`);
        } else {
          if (this.selectNoRenewTip === "three") {
            let data = {
              "tip": this.selectNoRenewTip,
              "date": Date.now() + 3 * 24 * 60 * 60 * 1e3
            };
            yield API.put(`api://base.local/storages/users/${this.user_id}/preference/renew_tip_date`, data);
          }
          if (this.selectNoRenewTip === "seven") {
            let data = {
              "tip": this.selectNoRenewTip,
              "date": Date.now() + 7 * 24 * 60 * 60 * 1e3
            };
            yield API.put(`api://base.local/storages/users/${this.user_id}/preference/renew_tip_date`, data);
          }
          if (this.selectNoRenewTip === "thirty") {
            let data = {
              "tip": this.selectNoRenewTip,
              "date": Date.now() + 30 * 24 * 60 * 60 * 1e3
            };
            yield API.put(`api://base.local/storages/users/${this.user_id}/preference/renew_tip_date`, data);
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("RenewVDDialog")
], RenewVDDialog.prototype, "renewVdDialog", 2);
RenewVDDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], RenewVDDialog);
export {
  RenewVDDialog as default
};
